import React from "react";
import styled from "styled-components";
import { style } from "./style";
import { focusOutline } from "./utils/focusOutlineStyle";

/**
 * TODO:
 *
 * 1. Add Drop Zone variation:
 *    https://www.figma.com/file/exezZpUqmYNaCq4Zz5Tafnqo/Walrus-Design-System?node-id=20256%3A0
 *
 * 2. Add button variations (e.g. secondary, tertiary)
 *    - Since we're re-styling a label, we had to mimic the stylings of
 *      our default Button component
 *
 * 3. Add loading state for larger file sizes
 *    - Not sure if this should be handled by the component or the caller
 */

// Adapted from
// https://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/
const FileSelectorInput = styled.input`
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 0.1px;
  z-index: -1;

  &:active + label {
    background-color: ${style.colors.blue.primary};
  }

  &:disabled + label {
    background-color: ${style.colors.blue.dark};
    cursor: default;
    opacity: ${style.vars.disabledOpacity};
  }

  &:focus + label {
    ${focusOutline()};
  }
`;

const FileSelectorLabel = styled.label`
  background-color: ${style.colors.blue.dark};
  border-radius: ${style.vars.borderRadius.base};
  color: ${style.colors.white};
  cursor: pointer;
  font-size: ${style.vars.fontSize.base};
  font-weight: ${style.vars.fontWeight.bold};
  letter-spacing: initial;
  padding: 12px 18px;
  text-transform: initial;
  transition: all ${style.vars.transitionSpeed.base} ${style.vars.easeInOutCubic};

  &:hover {
    background-color: ${style.colors.blue.primary};
    transition: all ${style.vars.transitionSpeed.base} ${style.vars.easeInOutCubic};
  }
`;

export type Props = {
  name: string;
  accept?: string;
  multiple?: boolean;
  disabled?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
};

export const FileSelector: React.FC<Props> = ({ children, name, accept, multiple, disabled, onChange }) => {
  return (
    <>
      <FileSelectorInput
        type="file"
        aria-label="file selector"
        id={name}
        name={name}
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={onChange}
      />
      <FileSelectorLabel htmlFor={name}>{children}</FileSelectorLabel>
    </>
  );
};
